import Ad from "@gik/ads/components/Ad";
import ZonesMap from "@gik/ads/maps/ZonesMap";
import type Article from "@gik/blog/models/Article";
import { useBemCN } from "@gik/core/utils/bemBlock";
import { Button } from "@gik/ui-legacy/Button";
import { ArticleTile } from "@gik/ui-legacy/gik/ArticleTile";
import React, { Fragment } from "react";

export interface IArticleGridProps {
	articles: Article[];
}

const blockName = "article-dynamic-loader";

export function ArticleDynamicLoader({ articles }: IArticleGridProps) {
	const pageSize = 8;

	const bem = useBemCN(blockName);
	const [articleDisplayLimit, setArticleDisplayLimit] =
		React.useState<number>(pageSize);

	function onLoadMoreClicked() {
		setArticleDisplayLimit(
			(articleDisplayLimit) => articleDisplayLimit + pageSize,
		);
	}

	return (
		<div {...bem()}>
			{articles
				.slice(0, articleDisplayLimit)
				.map((_, i, array) =>
					i % pageSize === 0 ? array.slice(i, i + pageSize) : null,
				)
				.filter((chunk) => chunk?.length)
				.map((chunk, i, array) => (
					<Fragment key={`chunk-${chunk[0].articleId}-${chunk.length}`}>
						<div {...bem("grid")}>
							{chunk.map((articleLink) => (
								<ArticleTile
									{...bem("article-tile")}
									key={articleLink.articleSlug}
									article={articleLink}
								/>
							))}
						</div>
						{i === array.length - 1 &&
							articles.length > articleDisplayLimit && (
								<div {...bem("show-more")}>
									<Button fullWidth onClick={() => onLoadMoreClicked()} pill>
										Load more
									</Button>
								</div>
							)}
						{chunk.length > pageSize / 2 ? (
							<Ad
								zone={ZonesMap.ArticleZones.LinkCard}
								mobileZone={ZonesMap.ArticleZones.LinkCardMobile}
							/>
						) : null}
					</Fragment>
				))}
		</div>
	);
}
